
import { Component, Vue } from 'vue-property-decorator';
import OsReportsOverview from '@/components/shared/reports/OsReportsOverview.vue';
import OsReportContentCategoriesOverview from '@/components/shared/reportcontentcategories/OsReportContentCategoriesOverview.vue';
import OsCustomerAssignedReportContentCategories from '@/components/shared/reportcontentcategories/OsCustomerAssignedReportContentCategories.vue';
import { ReportAudience } from '@/models/application';

@Component({
  computed: {
    ReportAudience() {
      return ReportAudience;
    }
  },
  components: {
    OsCustomerAssignedReportContentCategories,
    OsReportContentCategoriesOverview,
    OsReportsOverview
  }
})
export default class CustomerReportContentCategoriesIndex extends Vue {
  customerId!: string;

  async created() {
    this.customerId = this.$route.params.id;
  }
}
